import { UI } from '@cowprotocol/ui'

import styled from 'styled-components/macro'

export const TokenNotFound = styled.div`
  color: var(${UI.COLOR_LINK});
  font-weight: 500;
  padding: 10px 0;
  text-align: center;
`

export const LoaderWrapper = styled.div`
  text-align: center;
  margin: 20px 0 10px 0;
`

export const SectionTitleRow = styled.div`
  margin: 20px 0 8px;
`
